// extracted by mini-css-extract-plugin
export var actions = "_kg-d";
export var benefitCard = "_kg-a";
export var benefitIcon = "_kg-b";
export var benefitLabel = "_kg-c";
export var benefits = "_kg-9";
export var bodyText = "_kg-8";
export var closeButton = "_kg-2";
export var content = "_kg-3";
export var eyebrow = "_kg-4";
export var heading = "_kg-5";
export var image = "_kg-f";
export var imagePanel = "_kg-e";
export var modal = "_kg-0";
export var shell = "_kg-1";
export var title = "_kg-6";
export var titleOffer = "_kg-7";